var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "编辑对账单明细",
        width: "1350px",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "detail-table",
          attrs: {
            data: _vm.listData,
            size: "small",
            stripe: "",
            border: "",
            "header-cell-style": {
              background: "#f5f7fa",
              color: "#606266",
              fontWeight: "bold",
            },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "skuId",
              label: "skuID",
              "min-width": "80",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "skuCode",
              label: "编号",
              "min-width": "140",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "skuName",
              label: "名称",
              "min-width": "200",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "skuAttr",
              label: "销售属性",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "skuQuantity",
              label: "数量",
              "min-width": "70",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "skuPrice",
              label: "单价",
              "min-width": "80",
              align: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v("￥" + _vm._s(_vm.formatAmount(scope.row.skuPrice))),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "skuTotalPrice",
              label: "总价",
              "min-width": "80",
              align: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "￥" + _vm._s(_vm.formatAmount(scope.row.skuTotalPrice))
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "skuImg",
              label: "图片",
              "min-width": "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.skuImg
                      ? _c("el-image", {
                          staticStyle: { width: "46px", height: "46px" },
                          attrs: {
                            src: scope.row.skuImg,
                            "preview-src-list": [scope.row.skuImg],
                          },
                        })
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "发货状态", "min-width": "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            scope.row.isShipped === 1 ? "success" : "warning",
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.isShipped === 1 ? "已发货" : "未发货"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "关联售后", "min-width": "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._l(scope.row.aftersaleAndAmount || [], function (item) {
                      return _c(
                        "div",
                        { key: item ? item.afterSaleId : "no-id" },
                        [
                          item && item.afterSaleId
                            ? _c(
                                "span",
                                {
                                  staticStyle: { color: "#409EFF" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.navigateToAftersaleDetail(
                                        item.afterSaleId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.afterSaleId) +
                                      "-" +
                                      _vm._s(item.amount) +
                                      "元"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !scope.row.aftersaleAndAmount ||
                    scope.row.aftersaleAndAmount.length === 0
                      ? _c("span", [_vm._v("-")])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "supplierPrice",
              label: "成交结算金额",
              "min-width": "120",
              align: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "￥" + _vm._s(_vm.formatAmount(scope.row.supplierPrice))
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "actualSettlementAmount",
              label: "实际结算金额",
              "min-width": "130",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isEditing
                      ? _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: { size: "mini", precision: 2, min: 0 },
                          model: {
                            value: scope.row.actualCalculatedPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "actualCalculatedPrice", $$v)
                            },
                            expression: "scope.row.actualCalculatedPrice",
                          },
                        })
                      : _c("span", [
                          _vm._v(
                            "￥" +
                              _vm._s(_vm.formatAmount(scope.row.settlePrice))
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "lossAmount",
              label: "损失金额",
              "min-width": "130",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isEditing
                      ? _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: { size: "mini", precision: 2, min: 0 },
                          model: {
                            value: scope.row.editLossAmount,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "editLossAmount", $$v)
                            },
                            expression: "scope.row.editLossAmount",
                          },
                        })
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.lossAmount != null
                                ? "￥" + _vm.formatAmount(scope.row.lossAmount)
                                : "-"
                            )
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              "min-width": "100",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isEditing
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSaveItem(scope.row)
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCancelItem(scope.row)
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                        ]
                      : [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEditItem(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                        ],
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }